/*
 * @Author: your name
 * @Date: 2020-09-27 14:09:08
 * @LastEditTime: 2020-09-28 11:22:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-fs/src/pages/Settings/BalanceManage/model.js
 */
import fetch from '@/utils/fetch';

const model = {
  state: {
    balanceAccountInfo: {},
    cashHistoryList: [], // 提现记录表格
    cashHistoryListTotal: 0,
    unionShopId: 0,
    shopInfoName: '',
    cashShopList: [],
    submitCanUse: false,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { BalanceManage }, getState }) => ({
    async shopInfoChange(value) {
      const unionShopId = value.key;
      const shopInfoName = value.label;
      const { shop_id, sub_shop_id } = getState().basic;
      BalanceManage.setState({ unionShopId, shopInfoName });
      const data = await fetch('/saasmerchant/web/ping/withdrawal/account/info', {
        type: 'POST',
        useJson: true,
        params: {
          shopId: shop_id,
          unionShopId,
          subShopId: sub_shop_id,
        },
      });
      if (data) {
        BalanceManage.setState({
          balanceAccountInfo: {
            ...data,
            shopInfoName,
          },
        });
      } else {
        BalanceManage.setState({
          balanceAccountInfo: {},
        });
      }
    },
    async getCashShopList() {
      const { shop_id } = getState().basic;
      fetch('/saasmerchant/web/shop/getunionshoplist').then((res) => {
        if (res && res.length) {
          let result = [];
          const resFilter = res.filter((item) => {
            return item.unionShopId === shop_id;
          });
          if (resFilter.length > 0) {
            result = resFilter;
          } else {
            result = res;
          }
          BalanceManage.setState({
            cashShopList: result,
          });
          BalanceManage.shopInfoChange({
            key: result[0].unionShopId,
            label: result[0].unionShopName,
          });
        }
      });
    },
    async getCashHistoryList(params) {
      const { shop_id, sub_shop_id } = getState().basic;
      const dataSource = await fetch('/saasmerchant/web/ping/withdrawal/list', {
        params: {
          shopId: shop_id,
          subShopId: sub_shop_id,
          pageSize: 10,
          ...params,
        },
      });
      if (dataSource) {
        BalanceManage.setState({
          cashHistoryList: dataSource.list,
          cashHistoryListTotal: dataSource.total,
        });
      }
    },
    async confirmSwitchMessage(flag) {
      const { shop_id } = getState().basic;
      const switchAuto = await fetch('/saasmerchant/web/ping/withdrawal/configure', {
        type: 'POST',
        params: {
          shopId: shop_id,
          auto: flag,
        },
        useJson: true,
      });
      if (switchAuto) {
        const { balanceAccountInfo } = getState().BalanceManage;
        BalanceManage.setState({
          balanceAccountInfo: {
            ...balanceAccountInfo,
            autoWithdrawal: true,
          },
        });
        return true;
      }
      return false;
    },
    // 请求银行账户信息
    async getBankInfo() {
      const { unionShopId } = getState().BalanceManage;
      const { shop_id, sub_shop_id } = getState().basic;
      const data = await fetch('/saasmerchant/web/ping/withdrawal/bankcard/info', {
        params: {
          shopId: shop_id,
          unionShopId,
          subShopId: sub_shop_id,
        },
      });
      return data;
    },
    // 获取验证码
    async postVerifyCode(params) {
      const { unionShopId } = getState().BalanceManage;
      const { shop_id, sub_shop_id } = getState().basic;
      const data = await fetch('/saasmerchant/web/ping/withdrawal/apply', {
        type: 'POST',
        params: {
          shopId: shop_id,
          unionShopId,
          subShopId: sub_shop_id,
          ...params,
        },
        useJson: true,
      });
      return data;
    },
    // 提交表单
    async confirmGetCash(params) {
      BalanceManage.setState({ submitCanUse: true });
      const { unionShopId } = getState().BalanceManage;
      const { shop_id, sub_shop_id } = getState().basic;
      const data = await fetch('/saasmerchant/web/ping/withdrawal/confirm', {
        type: 'POST',
        params: {
          shopId: shop_id,
          unionShopId,
          subShopId: sub_shop_id,
          status: 'pending',
          ...params,
        },
        useJson: true,
      });
      if (data) {
        BalanceManage.setState({ submitCanUse: false });
      }
      return data;
    },
  }),
};

export default model;
